import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantSignUpService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_ParticipantSignUp_ParticipantSignUpCompletedResponseDto,
} from '../../services/wealthlane-customer-services';

const useGetSignUpCompleted = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_CustomerService_Dtos_ParticipantSignUp_ParticipantSignUpCompletedResponseDto
  | undefined,
  unknown
> => {
  const participantSignUpCompleted = useQuery(['getParticipantSignUpCompleted'], async () => {
    return await handleRequest(
      ParticipantSignUpService.getApiCustomerApiAppParticipantSignUpIsParticipantSignUpCompleted()
    );
  });

  return participantSignUpCompleted;
};

export default useGetSignUpCompleted;
